export const setDocumentTitleHelper = (title: string) => {
  document.title = title
}
